var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    this.products && this.ProductDetail(("sp_" + (this.products.spTimestamp)))
  )?_c('div',{attrs:{"id":"OtpVerificationMainPage"}},[_c('otp-header'),_c('main',[_c('otp-description',{staticClass:"otp-description py-2 container",attrs:{"productCoach":_vm.productCoach,"qrCodeUrl":_vm.qrCodeUrl,"products":_vm.products}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }